import { screenSm, screenXs } from 'constants/styles/breakpoints';
import { colors } from 'constants/styles/colors';
import styled from 'styled-components';

import { Divider, Space, Typography } from 'antd';
import type { HTMLAttributes } from 'react';

export const CourseDifficulty = styled.div`
  display: none;

  ${screenSm} {
    display: initial;

    text-transform: capitalize;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
    color: #57575c;
  }
`;
// antd's TextProps omits the generic DOM attributes it forwards at runtime, so the
// interactive props below have to be declared here.
export const GroupItemTitle = styled(Typography.Text)<
  { $openable?: boolean } & HTMLAttributes<HTMLSpanElement>
>`
  ${({ $openable }) =>
    $openable &&
    `
    cursor: pointer;

    &&:hover,
    &&:focus-visible {
      color: ${colors.dataVisualization.purple.dark};
    }
    &:hover .open-indicator,
    &:focus-visible .open-indicator {
      visibility: visible;
    }
  `}

  font-family: var(--font-family-base), Lato, sans-serif;
  color: ${({ theme }) => theme.default.colors.palette.Business_DarkThemeGeneralBackground};

  /* screenXs is a min-width query, so the desktop type has to live inside it:
     declared at the top level it would be overridden at every width above 480px. */
  font-weight: 450;
  font-size: 14px;
  line-height: 23px;

  ${screenXs} {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const VerticalDivider = styled(Divider).attrs(() => ({
  type: 'vertical',
}))`
  margin: 0;
  border-color: #888;
`;

export const BottomDataWrapper = styled(Space).attrs(() => ({ size: 10 }))`
  display: none;

  ${screenSm} {
    display: flex;
    font-weight: 450;
    font-size: 12px;
    line-height: 14px;
    color: #57575c;
  }
`;

export const GroupItemDataWrapper = styled(Space).attrs(() => ({
  direction: 'vertical',
  size: 5,
}))`
  display: flex;
  flex: 1;
`;

export const GroupItemContainer = styled(Space)`
  display: flex;
  align-self: stretch;
  padding: 10px;
  column-gap: 10px;
  align-items: center;
  background: #ffffff;
  border-width: 1px;
  border-style: solid;
  border-color: #f2f2f7;
  border-radius: 10px;

  ${screenSm} {
    border-radius: 0px 10px 10px 0px;
    border-left-width: 0px;
    padding: 10px 20px 10px 30px;
  }
`;

export const GroupItemRow = styled(Space)`
  height: 80px;

  ${screenSm} {
    height: 92px;
  }
`;

export const ButtonsWrapper = styled(Space).attrs(() => ({ size: 10, align: 'center' }))``;

export const OpenIndicator = styled.span`
  display: inline-block;
  margin-left: 8px;
  /* An inline-block aligns its bottom margin edge to the baseline, so this offset
     only has to cancel the 1.4px of transparent padding the icon's 24px viewBox
     leaves below the glyph, seating the glyph itself on the baseline. */
  vertical-align: -1.4px;
  visibility: hidden;
`;
